import React, { useEffect, useState } from "react";
import styles from "./ComplianceOwnerDashboard.module.css";

const colors: any = {};

export default function ActivityTypeStats({ filters, stats }: any) {
    const [activityTypeStats, setStats] = useState<any[]>([]);

    function getTagColor() {
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += Math.floor(Math.random() * 10);
        }
        return color;
    }

    useEffect(() => {
        if (stats) {
            setStats(Object.keys(stats).map((key: any) => {
                if (!colors[key]) {
                    colors[key] = getTagColor();
                }
                return { value: stats[key] || 0, label: key, style: { '--tag-color': colors[key] } as React.CSSProperties };
            }));
        }
    }, [stats]);

    return (
        <>
            <div className="d-flex flex-row mb-3 mx-2" style={{ gap: '0.75rem' }}>
                {
                    activityTypeStats.map(({ value, label, style }: any) => {
                        return (
                            <div className={styles.activityTypeTags} key={label} style={style}>
                                <div className="d-flex flex-row align-items-center gap-2 h-100">
                                    <label>{label}</label>
                                    <span>({value})</span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}